export default __webpack_public_path__ + "static/media/user_nft_04.4961a9bc.svg";